import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Button } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import StatusTag from '../components/compliance/StatusTag';
import PropertyWithModal from '../components/environmental/PropertyWithModal';

export const ReportsCols = [
    {
      title: 'Reports',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => <><CaretRightOutlined /><Link to={{ pathname: `/report/${record.id}`, state: { report: record }}}>{text}</Link></>,
    },
    {
      title: 'Date',
      dataIndex: 'date',
      render: (text) => moment(text).format('DD MMMM YYYY'),
    }
]


export const ComplianceCols = [
    {
        title: '#',
        key: 'id',
        width: 50,
        render: (text, record, index) => {
            return index + 1;
        },
        status: ['certification', 'verification', 'reception'], 
    },
    {
        title: 'Lot Number',
        key: 'lotNumber',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'lotNumber'],
        status: ['certification', 'verification', 'reception'],
        render: (lotNumber, record) => {
            const consortiumId = record.consortiumId;

            if (!lotNumber) return '';

            return (
                <Link 
                    to={`/supply-chain-tracking-results/${consortiumId}/${lotNumber}`}
                    style={{
                        color: '#228B22',   // 🔵 Change color here
                        fontWeight: 600,    // optional
                    }}
                >
                    <CaretRightOutlined /> {lotNumber}
                </Link>
            );
        }
    },
    {
        title: 'GTIN',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'GTIN'],
        key: 'GTIN',
        status: ['certification', 'verification', 'reception'], 
    },
    {
        title: 'Parcel ID',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'parcelID'],
        key: 'parcelID',
        status: ['certification', 'verification'], 
    },
    {
        title: 'Organization',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'readPoint', 'id'],
        key: 'organization',
        status: ['certification', 'verification', 'reception'], 
    },
    {
        title: 'Quantity',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo'],
        status: ['reception'],
        render: (traceInfo) => {
            if (!traceInfo) return 'N/A';

            const qty = traceInfo.quantity ?? 'N/A';
            const uom = traceInfo.unitOfMeasure ?? '';

            return `${qty} ${uom}`;
        }
    },
    {
        title: 'GLN',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'receptionGLN'],
        key: 'receptionGLN',
        status: ['reception'], 
    },
    {
        title: 'Name',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'receiverName'],
        key: 'receiverName',
        status: ['reception'], 
    },
    {
        title: 'Description',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'description'],
        key: 'description',
        status: ['reception'], 
    },
    {
        title: 'Country of Origin',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'countryOfOrigin'],
        key: 'country',
        status: ['certification', 'verification'], 
    },
    {
        title: 'Type',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'productType'],
        key: 'productType',
        status: ['certification'], 
    },
    {
        title: 'Verification Method',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'type'],
        key: 'verification',
        status: ['verification'], 
    },
    {
        title: 'Certification Method',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'eventCertified'],
        key: 'certification',
        status: ['certification'], 
    },
    {
        title: 'Date',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'timestamp'],
        key: 'timestamp',
        render: (text) => moment(text).format('DD MMMM YYYY'),
        status: ['verification'], 
    },
    {
        title: 'Date',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'certificationDate'],
        key: 'certificationDate',
        render: (text) => moment(text).format('DD MMMM YYYY'),
        status: ['certification'], 
    },
    {
        title: 'Date',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'receptionDate'],
        key: 'receptionDate',
        render: (text) => moment(text).format('DD MMMM YYYY'),
        status: ['reception'], 
    },
    {
        title: 'Status',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'result'],
        key: 'status',
        render: (text) => <StatusTag status={text} />,
        status: ['certification', 'verification'], 
    },
    {
        title: 'Documents',
        dataIndex: ['gs1Event', 'epcisBody', 'eventList', 0, 'ilmd', 'traceInfo', 'documents'],
        key: 'documents',
        status: ['certification'], 
    }
]


export const SupplyChainTrackingCols = [
    {
        title: 'Lot Number',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        render: (text, record) => (
            <Link 
                to={`/supply-chain-tracking-results/${record.consortiumId}/${record.lotNumber}`}
                style={{
                        color: '#228B22',   // 🔵 Change color here
                        fontWeight: 600,    // optional
                    }}
                >
                    <CaretRightOutlined /> {text}
            </Link>
        )
    },
    {
        title: 'GTIN',
        dataIndex: 'GTIN',
        key: 'GTIN',
        render: (text) => text,
    },
    {
        title: 'Producer',
        dataIndex: 'producerName',
        key: 'producerName',
        render: (text) => text,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (text, record) => 
            text !== null && text !== undefined ? `${text} ${record.uom || ''}` : '',
    },
    {
        title: 'Production Date',
        dataIndex: 'productionDate',
        key: 'productionDate',
        render: (text) => text ? moment(text).format('DD MMMM YYYY') : '',
    },
    {
        title: 'Purchase Order',
        dataIndex: 'purchaseOrder',
        key: 'purchaseOrder',
        render: (orders) => {
            if (Array.isArray(orders) && orders.length > 0) {
                return orders.join(', ');
            }
            return orders || '';
        },
    },
    {
        title: 'Consortium',
        dataIndex: 'consortiumId',
        key: 'consortiumId',
        render: (consortiumId) => {
            const consortiumMap = {
                101: 'Spain Pilot',
                102: 'Greece Pilot', 
                103: 'Serbia Pilot',
                104: 'Czech Republic Pilot'
            };
            return consortiumMap[consortiumId] || consortiumId;
        }
    }
];


export const environmentalColumns = [
    {
        title: '#',
        key: 'id',
        width: 50,
        render: (text, record, index) => {
            return index + 1;
        },
    },
    {
        title: 'Name',
        dataIndex: ['name'],
        key: 'name',
    },
    {
        title: 'Description',
        dataIndex: ['description'],
        key: 'description',
    },
    {
        title: '',
        key: 'link',
        dataIndex: ['@iot.id'],
        render: (text, record) => 
        <Link to={{ pathname: `/environmental-monitoring-results/${record['@iot.id']}` , state: {  datastream: record  }}}>
            <Button type="link" className="btnPrimary" style={{ padding: '16px 20px', backgroundColor: '#335001' , color: '#FFF'}}>
                View
            </Button>
        </Link>
    },
]


export const observationsColumns = (currentPage, pageSize) => [
    {
        title: '#',
        key: 'id',
        width: 100,
        render: (text, record, index) => {
            const globalIndex = (currentPage - 1) * pageSize + index + 1;
            return globalIndex;
        },
    },
    {
        title: 'Name',
        key: 'name',
        render: (text, record) => {
            const nameValue = record.parameters.foiId 
                ? record.parameters.foiId
                : record.parameters.name
            return nameValue;
        },
    },
    {
        title: 'Created At',
        dataIndex: 'phenomenonTime',
        render: (text) => moment(text).format('DD MMMM YYYY'),
    },
    {
        title: '',
        key: 'link',
        dataIndex: ['@iot.id'],
        render: (text, record) => 
        <Link to={{ pathname: `/observation/${record['@iot.id']}` , state: {  datastream: record  }}}>
            <Button type="link" className="btnPrimary" style={{ padding: '16px 20px', backgroundColor: '#335001' , color: '#FFF'}}>
                View
            </Button>
        </Link>,
    },
]


export const propertiesColumns = [
    {
        title: "Property",
        dataIndex: "property",
        key: "property",
        render: (text, record) => <PropertyWithModal property={text} details={record} />
    },
    {
        title: "Value",
        dataIndex: "value",
        key: "value",
    },
];